export const infrastructurePoints = {
  name: `infrastructurePoints`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, mun, cost, content, district, lyr_sub, lyr_name, name, address, lyr_cat, haz_wf, haz_fld, haz_eq2, haz_eq1, haz_damg, haz_tsu, haz_ls, haz_slr, haz_lev
    FROM solano_ci09_point_merge_x_hazard
  `,
  cartoCSS: `
    #layer {
      marker-width: 9;
      marker-fill: ramp([lyr_cat], (#ff8010, #2e97d5, #ff0000), ("High Potential Loss", "Transportation and Lifeline", "Essential Facilities"), =);
      marker-fill-opacity: 1;
      marker-allow-overlap: true;
      marker-line-width: 1;
      marker-line-color: #FFFFFF;
      marker-line-opacity: 1;
      marker-comp-op: src-over;
    }
  `,
  featureOverColumns: [
    "mun",
    "lyr_name",
    "name",
    "lyr_sub",
    "district",
    "address",
    "lyr_cat",
    "haz_wf",
    "haz_fld",
    "haz_eq2",
    "haz_eq1",
    "haz_damg",
    "haz_lev",
    "haz_ls",
    "haz_tsu",
    "haz_slr",
    "cost",
    "content",
  ]
}

export const infrastructurePointsCategories = {
  name: `infrastructurePointsCategories`,
  type: 'Category',
  source: infrastructurePoints.sql,
  field: 'mun',
  options: {
    limit: 100,
    operation: 'COUNT',
    operationColumn: 'cartodb_id'
  }
}

export const infrastructurePointsTypes = {
  name: `infrastructurePointsTypes`,
  type: 'Category',
  source: infrastructurePoints.sql,
  field: 'lyr_name',
  options: {
    limit: 100,
    operation: 'COUNT',
    operationColumn: 'cartodb_id'
  }
}

export const infrastructurePointsSum = {
  name: 'infrastructurePointsSum',
  type: 'Formula',
  source: infrastructurePoints.sql,
  field: 'cartodb_id',
  options: {
    operation: 'COUNT',
  }
}



